const displayExtraEmailButton = () => true;

export default displayExtraEmailButton;
